<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">

        <rect class="svg-block-background-color" width="20" height="20"/>
        <path :class="secondaryColor" d="M10,10.3c2.2,0,4.1-3,4.1-5.9S12.2,0,10,0S5.9,1.6,5.9,4.4S7.8,10.3,10,10.3z M13.5,11.3L10,14.8l-3.5-3.5
	c-3.7,0.9-5,3.2-5,5.5c0,3.8,3.4,3.2,8.5,3.2s8.5,0.6,8.5-3.2C18.5,14.5,17.2,12.2,13.5,11.3z"/>
</svg>

</template>

<script>
export default {
    name: "patientIcon",
    computed :{
        secondaryColor() {
          return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/patientIcon.vue